import NavChaptersList from './NavChaptersList';
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

export default function Nav() {
  const [darkMode, setDarkMode] = useState(getTheme());
  const [darkModeIcon, setDarkModeIcon] = useState([]);
  const getHtml = document.querySelector('html');

  function darkModeToggle() {
    if (!darkMode){
      setDarkMode(true);
    } else {
      setDarkMode(false);
    }
  }

  function getTheme() {
    const storedTheme = JSON.parse(localStorage.getItem('dark'));
    return storedTheme;
  }

  useEffect(() => {
    if (darkMode) {
      getHtml.classList.add('dark');
      setDarkModeIcon("M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z");
      localStorage.setItem('dark', JSON.stringify(true));
    } else {
      getHtml.classList.remove('dark');
      setDarkModeIcon("M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z");
      localStorage.setItem('dark', JSON.stringify(false));
    }
  }, [darkMode, getHtml])

	return (
    <nav className="sticky top-0 z-10">
      <div className="flex justify-between bg-neutral-900 text-neutral-100 px-4 py-2 items-center dark:border-b dark:border-neutral-100">
        <div className="font-bold font-source text-xl"><Link to="/">Arisu</Link></div>
        <div className="flex">
          <div className="relative group">
            <button className="flex items-baseline bg-neutral-800 hover:bg-neutral-700 px-2 py-1 rounded-lg">
              <span>Chapters</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="ml-1 w-3" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
              </svg>
            </button>
            <div className="whitespace-nowrap rounded-lg translate-y-2 absolute bg-neutral-900 dark:border dark:border-neutral-100 hidden group-focus-within:block my-1 overflow-hidden">
              <NavChaptersList link="/chapter1" text="Chapter I" />
              <NavChaptersList link="/chapter2" text="Chapter II" />
              <NavChaptersList link="/chapter3" text="Chapter III" />
              <NavChaptersList link="/chapter4" text="Chapter IV" />
              <NavChaptersList link="/chapter5" text="Chapter V" />
              <NavChaptersList link="/chapter6" text="Chapter VI" />
              <NavChaptersList link="/chapter7" text="Chapter VII" />
              <NavChaptersList link="/chapter8" text="Chapter VIII" />
              <NavChaptersList link="/chapter9" text="Chapter IX" />
              <NavChaptersList link="/chapter10" text="Chapter X" />
              <NavChaptersList link="/chapter11" text="Chapter XI" />
              <NavChaptersList link="/chapter12" text="Chapter XII" />
            </div>
          </div>
          <div className="ml-4 text-neutral-100 flex justify-center">
            <button onClick={darkModeToggle}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-4" viewBox="0 0 16 16">
                <path d={darkModeIcon} />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}